var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:`border border-solid border-${_vm.color}${
    _vm.colorIntensity ? '-' + _vm.colorIntensity : ''
  } rounded-full flex align-center justify-between
  ${_vm.size === 'small' ? 'h-10' : ''}
  ${_vm.size === 'normal' ? 'h-12' : ''}
  ${_vm.loading || _vm.disabled ? `opacity-50 cursor-not-allowed` : `transform active:translate-y-0.5`}
  hover:shadow-md
  transition duration-150 ease-in-out`,attrs:{"disabled":_vm.loading || _vm.disabled}},[_c('div',{class:`pl-4 pr-2 flex align-center justify-center text-lg whitespace-nowrap text-${_vm.color}${
      _vm.colorIntensity ? '-' + _vm.colorIntensity : ''
    }`},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',{class:`m-1 rounded-full
    ${_vm.size === 'small' ? 'w-8 h-8' : ''}
    ${_vm.size === 'normal' ? 'w-9 h-9' : ''}
    bg-${_vm.color}${_vm.colorIntensity ? '-' + _vm.colorIntensity : ''} flex align-center justify-center`},[(_vm.loading)?_c('Icon',{staticClass:"animate-spin",attrs:{"name":"mdi-loading","color":"white","size":"2xl"}}):_c('Icon',{attrs:{"name":_vm.icon,"color":"white","size":"2xl"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }